import { useMemo } from 'react';
import getScrollbarSize from '../utils/getScrollbarSize.js';

function useResizeBody(isOpen) {
  /**
   * Disable scroll while Popover is displaying
   */
  useMemo(() => {
    const bodyStyle = document.body.style;
    if (!isOpen) {
      bodyStyle.paddingRight = null;
      bodyStyle.overflow = null;
      return;
    }
    bodyStyle.paddingRight = `${getScrollbarSize(document)}px`;
    bodyStyle.overflow = 'hidden';
  }, [isOpen]);
}

export { useResizeBody as default };
//# sourceMappingURL=useResizeBody.js.map
